import React from "react";

type AchievementProgressBarProps = {
  value: number;
  max: number;
  height?: number | string;
  fontSize?: number | string;
  className?: string;
  style?: React.CSSProperties;
  darkMode?: boolean;
};

const AchievementProgressBar: React.FC<AchievementProgressBarProps> = ({
  value,
  max,
  height = 12,
  fontSize = 10,
  className = "",
  style,
  darkMode = false,
}) => {
  const isComplete = value >= max;
  const progressColor = isComplete ? "#22c55e" : "#3b82f6";
  const bgColor = darkMode ? "#374151" : "#d1d5db"; // gray-700 or gray-300
  const textColor = darkMode ? "#e5e7eb" : "#374151";

  return (
    <div className={`relative w-full ${className}`} style={{ height, ...style }}>
      <div className="absolute left-0 top-0 h-full w-full rounded-full" style={{ background: bgColor }} />
      <div
        className="absolute left-0 top-0 h-full rounded-full"
        style={{
          width: `${Math.min((value / max) * 100, 100)}%`,
          background: progressColor,
          transition: "width 0.3s",
        }}
      />
      <div
        className="absolute w-full h-full flex items-center justify-center font-semibold"
        style={{ fontSize, color: textColor }}
      >
        {`${value}/${max}`}
      </div>
    </div>
  );
};

export default AchievementProgressBar;
